var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "report-item-funnel" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "div",
            { staticClass: "title-header" },
            [
              _c(
                "span",
                [
                  _vm.option.title
                    ? _c("span", [_vm._v(_vm._s(_vm.option.title))])
                    : _vm._e(),
                  _vm.option.tooltip
                    ? [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top-start" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.option.tooltip),
                                  },
                                }),
                              ]
                            ),
                            _c("i", {
                              staticClass: "icon-a-01wenhao iconfont-el icon",
                            }),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.option.link
                ? [
                    _c("a", { attrs: { href: _vm.option.link } }, [
                      _vm._v(_vm._s(_vm.option.linkName)),
                    ]),
                  ]
                : _vm._e(),
              _c(
                "div",
                { staticClass: "filter-select-wrap" },
                [
                  _vm.option.otherTip
                    ? _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.option.otherTip)),
                      ])
                    : _vm._e(),
                  _vm.option.filterParam
                    ? _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          attrs: {
                            placeholder: _vm.option.filterPlaceholder
                              ? _vm.option.filterPlaceholder
                              : "请选择",
                          },
                          on: { change: _vm.handleFilter },
                          model: {
                            value: _vm.option.filter,
                            callback: function ($$v) {
                              _vm.$set(_vm.option, "filter", $$v)
                            },
                            expression: "option.filter",
                          },
                        },
                        _vm._l(_vm.option.filterOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
          _vm.option.tip
            ? _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.option.tip)),
              ])
            : _vm._e(),
          _vm._t("other", null, { option: _vm.option }),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "table-box",
          style:
            "width: 100%;height:" +
            _vm.option.height +
            ";overflow:hidden;position:relative;",
        },
        [
          _c(
            "div",
            { staticClass: "header-content" },
            _vm._l(_vm.option.columns, function (item) {
              return _c("div", { key: item.id, staticClass: "item" }, [
                _vm._v(_vm._s(item.label)),
              ])
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "cotent-info" },
            _vm._l(_vm.option.tableData, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "info-item" },
                [
                  _vm._t("row", null, { item: item, index: index }),
                  _c("div", { staticClass: "before-item" }),
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }